module.exports = __webpack_public_path__ + "img/KSC09255.41597a38.jpg";